const state = () => ({
  quotes: [],
  latestQuotes: {},
  healthPurchaseHistory: {},
  quotes_fetched_at: null,
  quotes_user_id: null,
  quotes_revision: 0,
  // true while the API withholds quotes until the member verifies their email (CLUB-899)
  quotes_verification_required: false
})

export default state
